export const stats = {
  table: {
    field: {
      campaign: 'Кампания',
      campaign_id: 'ID Кампании',
      task_number: 'Номер в задаче',
      src: 'Исходящий',
      dst: 'Входящий',
      date_time: 'Дата и Время',
      duration: 'Длительность',
      client_action: 'Действие клиента',
      cost: 'Стоимость',
      status: 'Статус'
    }
  },

  filter: {
    campaign: '@:autoinformer.stats.table.field.campaign',
    status: '@:autoinformer.stats.table.field.status',
    task_number: '@:autoinformer.stats.table.field.task_number',
    src: '@:autoinformer.stats.table.field.src',
    dst: '@:autoinformer.stats.table.field.dst',
    client_action: '@:autoinformer.stats.table.field.client_action'
  },

  state: {
    ANSWERED: 'Отвеченный',
    NO_ANSWER: 'Неотвеченный',
    FAILED: 'Ошибка',
    PROGRESS: 'В процессе',
    SUBSCRIBER_ABSENT: 'Недоступен',
    CALL_TIMED_OUT: 'Превышено время ожидания',
    CLIENT_DROPPED_CALL_OR_BUSY: 'Сбросил звонок или занят',
    NO_HUMAN: 'Автоответчик'
  }
};
